export default {
    0: 'Нормальный',
    1: 'Ускоренный',
    2: 'Замедленный'
}